import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { useIntl } from 'react-intl';

const FileWatermarkedSelect = ({
  watermarked,
  handleChange,
}) => {
  const intl = useIntl();

  return (
    <>
      <FormGroup>
        <Label for="radioWatermark-Add" check>
          <Input
            type="radio"
            name="watermark"
            id="radioWatermark-Add"
            className="input-radio radio-s"
            onChange={() => handleChange(true)}
            checked={watermarked}
          />
          <span>
            {intl.formatMessage({ defaultMessage: 'Add watermark' })}
          </span>
        </Label>
      </FormGroup>
      <FormGroup>
        <Label for="radioWatermark-Remove" check>
          <Input
            type="radio"
            name="watermark"
            id="radioWatermark-Remove"
            className="input-radio radio-s"
            onChange={() => handleChange(false)}
            checked={!watermarked}
          />
          <span>
            {intl.formatMessage({ defaultMessage: 'Remove watermark' })}
          </span>
        </Label>
      </FormGroup>
    </>
  );
};

const mapStateToProps = state => ({
  fileStatuses: state.Files.statuses,
});

FileWatermarkedSelect.propTypes = {
  watermarked: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(FileWatermarkedSelect);
